import classNames from 'classnames';

import React, { useCallback, useState } from 'react';

import { Icon } from '../../icon';

import styles from './skeleton.scss';

const ELEMENTS_COUNT = 5;

export const FloatingMenuSkeleton = () => {
  const [isOpen, setIsOpen] = useState(false);

  const menuClasses = classNames(styles.menu, { [styles.open]: isOpen });
  const overlayClasses = classNames(styles.overlay, { [styles.open]: isOpen });

  const toggleMenu = useCallback((e) => {
    e.preventDefault();
    setIsOpen((prev) => !prev);
  }, []);

  return (
    <div data-testid="floating-menu-skeleton" className={menuClasses}>
      {isOpen && (
        <>
          {new Array(ELEMENTS_COUNT).fill(0).map((_, index) => (
            <div className={styles.item} key={index}>
              <div className={styles.image}>
                <Icon size={24} />
              </div>
            </div>
          ))}
        </>
      )}
      <button onClick={toggleMenu} data-testid="menu-button" className={styles.button}>
        <Icon size={24} name={isOpen ? 'close' : 'menu'} />
      </button>
      {isOpen && <div className={overlayClasses}></div>}
    </div>
  );
};

FloatingMenuSkeleton.displayName = 'FloatingMenuSkeleton';
